import { render, staticRenderFns } from "./sidenav.vue?vue&type=template&id=1c40f872&scoped=true&"
import script from "./sidenav.vue?vue&type=script&lang=js&"
export * from "./sidenav.vue?vue&type=script&lang=js&"
import style0 from "./sidenav.vue?vue&type=style&index=0&id=1c40f872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c40f872",
  null
  
)

export default component.exports